type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;
type LoggerLike = Pick<Console, "warn">;

function rowsFromResult<T>(result: unknown): T[] {
  if (Array.isArray(result)) return result as T[];
  if (result && typeof result === "object" && Array.isArray((result as { rows?: unknown[] }).rows)) {
    return (result as { rows: T[] }).rows;
  }
  return [];
}

export function parseRealtimeConnectionLimit(rawFeatures: unknown): number | undefined {
  let features: Record<string, unknown> = {};
  if (typeof rawFeatures === "string" && rawFeatures.trim()) {
    try {
      features = JSON.parse(rawFeatures);
    } catch {
      return undefined;
    }
  } else if (rawFeatures && typeof rawFeatures === "object") {
    features = rawFeatures as Record<string, unknown>;
  }

  const limit = Number(features.wsConnections);
  if (!Number.isFinite(limit) || limit <= 0) return undefined;
  return Math.floor(limit);
}

export async function resolveRealtimeConnectionLimit(params: {
  appName: string;
  rawSql: RawSql;
  logger?: LoggerLike;
}): Promise<number | undefined> {
  try {
    const result = await params.rawSql(
      `SELECT pt.features
       FROM apps a
       LEFT JOIN user_credits uc ON uc.user_id = a.user_id
       LEFT JOIN pricing_tiers pt ON pt.id = COALESCE(uc.plan, a.plan, 'free')
       WHERE a.name = $1
       LIMIT 1`,
      [params.appName],
    );
    const rows = rowsFromResult<{ features?: unknown }>(result);
    return parseRealtimeConnectionLimit(rows[0]?.features);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    params.logger?.warn(
      `[ws-gateway] failed to resolve realtime limit for ${params.appName}:`,
      message.slice(0, 100),
    );
    return undefined;
  }
}
